<template>
    <div class="empty--wrap" v-bind="$attrs">
        <div class="empty--image" :class="[position]">
            <SvgAsset
                v-if="state === 'error' || state === 'error_custom' || state === 'network_error'" 
                name="error" 
            />
            <SvgAsset
                v-else-if="state === 'no_result'"
                name="search" 
            />
            <slot v-else-if="customIcon" name="custom-icon" />
            
            <SvgAsset
                v-else
                :name="iconName"
            />
        </div>

        <div class="empty--text" :class="[position]">   
            <div>
                <h2 class="empty--title mb--5">
                    {{ computeTextData.title }}
                </h2>
                <p v-if="computeTextData.subtitle" class="empty--subtitle error">
                    {{ computeTextData.subtitle }}
                </p>
            </div>

            <div class="empty--button" :class="[position]">
                <template v-if="btnState === 'custom'">
                    <slot name="button" />
                </template>
                <template v-else-if="btnState === 'none'" />
                <template v-else-if="btnState === 'default'">
                    <BaseButton 
                        v-if="state === 'error' || state === 'network_error' || state === 'error_custom'"
                        label="Reload" 
                        icon-name="refresh" 
                        icon-width="16px" 
                        prefix-icon 
                        :disabled="btnDisabled"
                        @submit="$emit('action')"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import SvgAsset from "../../ui/icons/SvgAssets.vue";
import BaseButton from "../../ui/buttons/BaseButton.vue";

export default {
    name: "EmptyPage",
    
    components: { SvgAsset, BaseButton },

    props: {
        btnState: {
            type: String,
            default: "default",
            validator: (value) => {
                return ["none", "custom", "default"].includes(value);
            },
        },
        position: {
            type: String,
            default: "center",
            validator: (value) => {
                return ["left", "center"].includes(value);
            },
        },
        customIcon: {
            type: Boolean,
            default: false,
        },
        btnDisabled: {
            type: Boolean,
            default: false,
        },
        state: {
            type: String,
            default: "",
            validator: (value) => {
                return ["error", "error_custom", "empty_custom", "no_result", "empty"].includes(value);
            },
        },
        subtitle: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "",
        },
        iconName: {
            type: String,
            default: "",
        },
    },

    computed: {
        computeTextData() {                        
            switch (this.state) {
            case "error":
                return {
                    title: "Unable to load page",
                    subtitle: "Something happened while trying to fetching data for this page",
                };
            case "network_error":
                return {
                    title: "Network Error",
                    subtitle: "Check your internet connection before attempting to reload page",
                };
            case "no_result":
                return {
                    title: " No result found",
                    subtitle: "Maybe try a different search keyword?",
                };
            case "empty_custom":
            case "error_custom":
                return {
                    title: this.title,
                    subtitle: this.subtitle,
                };
            case "empty":
                return {
                    title: `You have no ${this.type}s `,
                    subtitle: `Your ${this.type}s will show up here when you create them.`,
                };
            default:
                return {
                    title: `You have no ${this.type}s`,
                    subtitle: `Your ${type}s will show up here when you create them.`,
                };
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .empty {
        &--wrap {
            max-width: 550px;
            margin: 6rem auto;
        }

        &--image {
            width: 100%;
            display: flex;

            &.center {
                justify-content: center;
                align-items: center;
            }

            &.left {
                justify-content: flex-start;
                align-items: flex-start;
            }
        }

        &--text {
            margin-top: 1.25rem;
            display: flex;
            flex-direction: column;
            
            &.center {
                text-align: center;
                justify-content: center;
                align-items: center;
            }

            &.left {
                text-align: left;
                justify-content: flex-start;
                align-items: flex-start;
            }
        }

        &--title {
            font-size: 1rem;
            color: #1a1f36;
            font-weight: 600;
        }
        
        &--subtitle {
            color: #697386;
            font-size: 0.875rem;
            max-width: 390px;
            margin-top: 5px;

            &.error {
                max-width: 440px;
            }
        }

        &--button {
            display: flex;
            margin-top: 25px;

            &.center {
                justify-content: center;
                align-items: center;
            }

            &.left {
                justify-content: flex-start;
                align-items: flex-start;
            }
        }
    }  
</style>